import React from "react";
const OverflowWrapperContext = /*#__PURE__*/React.createContext();
export default OverflowWrapperContext;